import {
  Box,
  Flex,
  Spacer,
  Image,
  HStack,
  IconButton,
  VStack,
  Button,
  Text,
  Grid,
  GridItem,
  useBreakpointValue,
} from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaUser,
  FaMinus,
  FaTimes,
  FaChevronRight,
  FaChevronLeft,
} from "react-icons/fa";
import { FaBoxOpen } from "react-icons/fa";
import logo from "../../assets/logo/logo111.png";
import logo1 from "../../assets/logo/logo21.png";
import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../redux/feature/categorySlice";
import { useNavigate } from "react-router-dom";
import B1 from "../../assets/home/bracelate.png";
import B2 from "../../assets/home/blue_pendant.png";
import B3 from "../../assets/watchesandjewellery/B4.jpeg";

const MotionBox = motion(Box);

const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedSubRoute, setSelectedSubRoute] = useState(null);
  const drawerRef = useRef(null);
  const token = localStorage.getItem("token");
  const isLoggedIn = !!token;
  const location = useLocation();
  const [scrollY, setScrollY] = useState(0);
  const [showNavbar, setShowNavbar] = useState(true);
  const lastScrollY = useRef(0);

  const isMobile = useBreakpointValue({ base: true, md: false });

  const dispatch = useDispatch();
  const { list: categories } = useSelector((state) => state.category);

  const navigate = useNavigate();

  const handleUserClick = () => {
    navigate(isLoggedIn ? "/overview" : "/login");
  };

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  // Hide on scroll down, show on scroll up
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setShowNavbar(false); // Scrolling down
      } else {
        setShowNavbar(true); // Scrolling up
      }
      lastScrollY.current = currentScrollY;
      setScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        drawerRef.current &&
        !drawerRef.current.contains(event.target) &&
        selectedSubRoute === null
      ) {
        setIsDrawerOpen(false);
        setOpenMenu(null);
        setSelectedSubRoute(null);
      }
    };

    if (isDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDrawerOpen, selectedSubRoute]);

  const collection = [
    { name: "Flower", image: B1 },
    { name: "Butterfly", image: B2 },
    { name: "Clouds", image: B3 },
    { name: "Birds", image: B1 },
  ];

  const toggleMenu = (index) => {
    setOpenMenu(openMenu === index ? null : index);
    setSelectedSubRoute(null);
  };

  const handleDrawerToggle = () => {
    setIsDrawerOpen((prev) => !prev);
    if (isDrawerOpen) {
      setOpenMenu(null);
      setSelectedSubRoute(null);
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsDrawerOpen(false);
    setOpenMenu(null);
    setSelectedSubRoute(null);
  };

  const handleBackClick = () => {
    setSelectedSubRoute(null);
  };

  const categorySubRoutes = categories.map((cat) => ({
    name: cat.name,
    // path: `/high-jewellery?category=${cat._id}`,
    id: cat._id,
    hasSubSubRoutes: false,
  }));

  // const bespokeCategory = categories.find(cat => cat.name === "Bespoke");
  // const bespokeCollections = bespokeCategory?.collection || [];

  const menuItems = [
    {
      name: "High-Jewellery",
      path: "/high-jewellery",
      subRoutes: [],
    },
    {
      name: "Jewellery",
      path: "/jewellery",
      subRoutes: Array.isArray(categorySubRoutes) ? categorySubRoutes : [],
    },
    {
      name: "Watches",
      path: "/jewellery/685240bb5548827243a4fbb9",
      subRoutes: [],
    },
    {
      name: "Brooch ",
      path: "/jewellery/68524d495548827243a4fc37",
      subRoutes: [],
    }
    ,
    {
      name: "Bespoke",
      subRoutes: [
        { name: "Rings",  path: `/bespoke/rings`, redirectOnClick: true },
        { name: "Bracelets",  path: `/bespoke/bracelets`, redirectOnClick: true },
        { name: "Pendent",  path: `/bespoke/pendent`, redirectOnClick: true },
        { name: "Earrings",  path: `/bespoke/earrings`, redirectOnClick: true },
        { name: "Necklace",  path: `/bespoke/necklace`, redirectOnClick: true },
      ]
    },
    {
      name: "About R'Rumi",
      subRoutes: [
        { name: "About Us", path: "/about-us", redirectOnClick: true },
        { name: "Store Locator", path: "/store", redirectOnClick: true },
        {
          name: "Crafstman & Certification",
          path: "/craftsman",
          redirectOnClick: true,
        },
        { name: "Our Services", path: "/services", redirectOnClick: true },
        {
          name: "Contact & Appointment",
          path: "/appointment",
          redirectOnClick: true,
        },
      ],
    }
  ].filter(Boolean);

  return (
    <MotionBox
      as="header"
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={100}
      px={{ base: 4, md: 10 }}
      py={4}
      initial={{ y: 0 }}
      animate={{ y: showNavbar ? 0 : -100 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      bg={
        location.pathname === "/" && scrollY < 100 ? "transparent" : "#012E2D"
      }
      boxShadow={scrollY > 100 ? "lg" : "none"}
    >
      <Flex align="center">
        <Button
          bg="transparent"
          color="white"
          onClick={handleDrawerToggle}
          _hover={{ bg: "transparent" }}
          _active={{ bg: "transparent" }}
          leftIcon={
            isDrawerOpen ? (
              <FaTimes color="white" />
            ) : (
              <Box as="span" fontSize="2xl">
                ≒
              </Box>
            )
          }
          fontWeight="semibold"
          fontSize="md"
        >
          {isDrawerOpen ? "Close" : ""}
        </Button>

        <Spacer />

        <Link to="/">
          <Image
            src={location.pathname === "/" && scrollY < 100 ? logo1 : logo}
            alt="logo"
            width="200px"
            cursor="pointer"
            ml={!isLoggedIn ? -8 : 0}
          />
        </Link>

        <Spacer />

        <HStack
          spacing={{ base: 3, md: 6 }}
          color="white"
          fontSize={{ base: "md", md: "lg" }}
          cursor="pointer"
        >
          <Box onClick={handleUserClick}>
            <FaUser />
          </Box>

          {isLoggedIn && (
            <Link to="/shopping-bag">
              <Box cursor="pointer">
                <FaBoxOpen size={"23px"} />
              </Box>
            </Link>
          )}
        </HStack>
      </Flex>

      {/* Main Drawer - Mobile */}
      <AnimatePresence>
        {isDrawerOpen && isMobile && (
          <MotionBox
            ref={drawerRef}
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            bg="white"
            zIndex={110}
            boxShadow="xl"
          >
            <Flex justify="space-between" align="center" p={6}>
              <Flex
                align="center"
                gap={2}
                cursor="pointer"
                onClick={handleDrawerToggle}
              >
                <FaTimes size={20} color="black" />
                <Text fontSize="lg">Close</Text>
              </Flex>
            </Flex>

            <Box p={6} overflowY="auto" height="calc(100vh - 80px)">
              {menuItems.map((item, index) => (
                <Box key={index} mb={4}>
                  <Flex
                    align="center"
                    justify="space-between"
                    cursor="pointer"
                    onClick={() => {
                      if (item.subRoutes?.length > 0) {
                        setSelectedSubRoute(item);
                      } else if (item.path) {
                        handleNavigation(item.path);
                      }
                    }}
                  >
                    <Text fontSize="md" fontWeight="medium">
                      {item.name}
                    </Text>
                    {item.subRoutes?.length > 0 && (
                      <IconButton
                        size="sm"
                        icon={<FaChevronRight />}
                        variant="ghost"
                        aria-label="Expand"
                        cursor="pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleMenu(index);
                        }}
                      />
                    )}
                  </Flex>
                </Box>
              ))}
            </Box>
          </MotionBox>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isDrawerOpen && selectedSubRoute && isMobile && (
          <MotionBox
            key="subRoutesMobile"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            bg="white"
            zIndex={120}
          >
            <Flex
              align="center"
              p={6}
              borderBottom="1px solid"
              borderColor="gray.100"
            >
              <IconButton
                icon={<FaChevronLeft />}
                variant="ghost"
                aria-label="Back"
                onClick={handleBackClick}
                mr={0}
              />
              <Text fontSize="xl" fontWeight="bold">
                {selectedSubRoute.name}
              </Text>
            </Flex>

            <Box p={6} overflowY="auto" height="calc(100vh - 80px)">
              {/* Show jewellery options first (excluding specific categories) */}
              {selectedSubRoute.subRoutes?.length > 0 && (
                <>
                  {selectedSubRoute.subRoutes
                    .filter(
                      (item) =>
                        !["Watch", "High Jewellery", "Brooches"].includes(
                          item.name
                        )
                    )
                    .map((item, index) => (
                      <Box
                        key={`option-${index}`}
                        onClick={() =>
                          handleNavigation(item.path || `/jewellery/${item.id}`)
                        }
                        cursor="pointer"
                        py={3}
                        borderBottom="1px solid"
                        borderColor="gray.100"
                      >
                        <Text fontSize="md">{item.name}</Text>
                      </Box>
                    ))}

                  {/* Add some spacing between options and collections */}
                  {selectedSubRoute.name === "Jewellery" && (
                    <>
                      <Box my={6}>
                        {/* <Text fontSize="lg" fontWeight="bold" mb={4}>
                          Collections
                        </Text> */}
                        <Grid templateColumns="1fr 1fr" gap={4}>
                          {collection.map((item, index) => (
                            <GridItem key={`collection-${index}`}>
                              <Box
                                onClick={() =>
                                  handleNavigation(
                                    `/discover-all?collection=${item.name}`
                                  )
                                }
                                cursor="pointer"
                              >
                                <Image
                                  src={item.image}
                                  w="100%"
                                  h="120px"
                                  objectFit="cover"
                                  borderRadius="md"
                                />
                                <Text
                                  mt={2}
                                  fontWeight="medium"
                                  textAlign="center"
                                >
                                  {item.name}
                                </Text>
                              </Box>
                            </GridItem>
                          ))}
                        </Grid>
                      </Box>
                    </>
                  )}
                </>
              )}
            </Box>
          </MotionBox>
        )}
      </AnimatePresence>

      {/* Original Desktop Drawer and Panels (unchanged) */}
      <AnimatePresence>
        {isDrawerOpen && !isMobile && (
          <MotionBox
            ref={drawerRef}
            initial={{ x: "-100%", y: 0 }}
            animate={{ x: 0, y: showNavbar ? 0 : 100 }}
            exit={{ x: "-100%" }}
            transition={{ duration: 0.3 }}
            position="fixed"
            top={0}
            left={0}
            width="240px"
            height="100vh"
            bg="white"
            zIndex={110}
            boxShadow={selectedSubRoute !== null ? "" : "xl"}
          >
            <Flex justify="space-between" align="center" p={6}>
              <Flex
                align="center"
                gap={2}
                cursor="pointer"
                onClick={handleDrawerToggle}
              >
                <FaTimes size={20} color="black" />
                <Text fontSize="lg">Close</Text>
              </Flex>
            </Flex>

            <Box p={6} overflowY="auto" height="calc(100vh - 80px)">
              {menuItems.map((item, index) => {
                const hasSubRoutes =
                  item.subRoutes && item.subRoutes.length > 0;

                return (
                  <Box key={index} mb={4}>
                    <Flex
                      align="center"
                      justify="space-between"
                      cursor="pointer"
                      onClick={() => {
                        if (hasSubRoutes) {
                          setSelectedSubRoute(item);
                        } else if (item.path) {
                          handleNavigation(item.path);
                        }
                      }}
                    >
                      <Text fontSize="md" fontWeight="medium">
                        {item.name}
                      </Text>
                      {hasSubRoutes && (
                        <IconButton
                          size="sm"
                          icon={
                            openMenu === index ? (
                              <FaMinus />
                            ) : (
                              <FaChevronRight />
                            )
                          }
                          variant="ghost"
                          aria-label="Expand"
                          cursor={"pointer"}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleMenu(index);
                          }}
                        />
                      )}
                    </Flex>
                  </Box>
                );
              })}
            </Box>
          </MotionBox>
        )}
      </AnimatePresence>

      {/* Original Desktop SubRoutes Panel */}
      <AnimatePresence>
        {isDrawerOpen && selectedSubRoute && !isMobile && (
          <MotionBox
            key="subSubRoutes"
            initial={{ left: 0, y: 0 }}
            animate={{ left: "240px", y: showNavbar ? 0 : 100 }}
            exit={{ left: "-280px" }}
            transition={{ duration: 0.3 }}
            position="fixed"
            top={0}
            width={
              ["Watches", "Accessories"].includes(selectedSubRoute?.name)
                ? "25%"
                : "280px"
            }
            height="100vh"
            bg="white"
            zIndex={109}
          >
            <MotionBox
              key={selectedSubRoute.name}
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ duration: 0.3 }}
              p={6}
            >
              <VStack align="start" spacing={4}>
                <Text fontSize="xl" fontWeight="bold">
                  {selectedSubRoute.name}
                </Text>
                {selectedSubRoute.subRoutes?.length > 0 ? (
                  selectedSubRoute.subRoutes
                    .filter(
                      (item) =>
                        !["High Jwellery", "Watch", "Brooches"].includes(
                          item.name
                        )
                    )
                    .map((item, index) => (
                      <Box
                        key={index}
                        onClick={() => {
                          handleNavigation(
                            item.path || `/jewellery/${item.id}`
                          );
                        }}
                        cursor="pointer"
                      >
                        <Text fontSize="sm" pl={2}>
                          {item.name}
                        </Text>
                      </Box>
                    ))
                ) : (
                  <Text fontSize="sm" pl={2} color="gray.400">
                    No Sub Items
                  </Text>
                )}
              </VStack>
            </MotionBox>
          </MotionBox>
        )}
      </AnimatePresence>

      {/* Original Desktop Product Preview Panel */}
      {/* Original Desktop Product Preview Panel */}
      <AnimatePresence>
        {isDrawerOpen &&
          selectedSubRoute &&
          !isMobile &&
          !["Bespoke", "About R'Rumi"].includes(selectedSubRoute.name) && (
            <MotionBox
              key="productPreview"
              initial={{ left: 0, y: 0 }}
              animate={{ left: "520px", y: showNavbar ? 0 : 100 }}
              exit={{ left: "-450px" }}
              transition={{ duration: 0.3 }}
              position="fixed"
              top={0}
              width="450px"
              height="100vh"
              bg="white"
              zIndex={90}
            >
              <MotionBox
                key={selectedSubRoute.name + "-products"}
                initial={{ x: "-100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                p={6}
              >
                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
                  {collection?.map((collectionName, index) => (
                    <GridItem key={index}>
                      <Box
                        onClick={() => {
                          handleNavigation(
                            `/discover-all?collection=${collectionName.name}`
                          );
                        }}
                      >
                        <Image
                          src={collectionName.image}
                          w="200px"
                          h="160px"
                          objectFit="cover"
                          cursor="pointer"
                        />
                        <Text fontWeight="bold" color={"black"} fontSize="lg">
                          {collectionName.name}
                        </Text>
                      </Box>
                    </GridItem>
                  ))}
                </Grid>
              </MotionBox>
            </MotionBox>
          )}
      </AnimatePresence>

      {/* Original Desktop Background Image Panel */}
      <AnimatePresence>
        {isDrawerOpen &&
          selectedSubRoute &&
          !isMobile &&
          !["Bespoke", "About R'Rumi"].includes(selectedSubRoute.name) && (
            <MotionBox
              key={selectedSubRoute.name + "-bg"}
              initial={{ x: "-100%", y: 0 }}
              animate={{ x: "60%", y: showNavbar ? 0 : 100 }}
              exit={{ x: "-105%" }}
              transition={{ duration: 0.3 }}
              position="fixed"
              top={0}
              height="100vh"
              w="full"
              width={
                ["Watches", "Accessories"].includes(selectedSubRoute?.name)
                  ? "63%"
                  : "full"
              }
              zIndex={80}
              bg={`url(${B3})`}
              bgSize="contain"
              bgRepeat="no-repeat"
              onClick={() => setSelectedSubRoute(null)}
            >
              <Box
                cursor={"pointer"}
                position="absolute"
                top="85%"
                left={
                  ["Watches", "Accessories"].includes(selectedSubRoute?.name)
                    ? "26%"
                    : "19%"
                }
                transform="translate(-50%, -50%)"
                textAlign="center"
                color="white"
                px={8}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigation("/discover-all");
                }}
              >
                <Text
                  mt={2}
                  fontSize="md"
                  textTransform="uppercase"
                  borderBottom="2px solid white"
                  display="inline-block"
                >
                  Discover the Collection
                </Text>
              </Box>
            </MotionBox>
          )}
      </AnimatePresence>
    </MotionBox>
  );
};

export default Navbar;
